import { Container, Grid, Typography } from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';


import deenfund from "../../../assets/imgs/products/DEENCONNECT-deenfund-masjid-org-online-donation-logo.png"
import deenconnect from "../../../assets/imgs/products/DEENCONNECT-manage-masjid-organization-logo.png"
import webformasjid from "../../../assets/imgs/products/DEENCONNECT-website-for-masjid-organization-development-logo.png"

import styles from "./OthersProducts.module.css";
import Buttons from "../../Button/Button";

const OthersProducts = () => {
  return (
    <>
      <div style={{ margin: "72px 0", padding: "72px 0", borderTop: '1px solid #e4e8ec', borderBottom: '1px solid #e4e8ec' }}>
        <Container>
          <Typography
            variant="h3"
            textAlign="center"
            fontSize="2rem"
            sx={{ mb: 3, fontWeight: "700", fontSize: '34px' }}
          >
            Other products by us
          </Typography>
          <Typography
            variant="h6"
            textAlign="center"
            fontSize="2rem"
            sx={{ m: 0, fontWeight: "400", fontSize: '20px', color: '#676C7B' }}
          >
            We are developing tools for our institutions to adapt, upgrade and better <br /> engage with communities and next generations of Muslims.
          </Typography>

          <div className={styles.bodyContainer}>
            <Grid container spacing={5} justifyContent="center"  alignItems="flex-end">
              <Grid item xs={12} sm={6} md={4} lg={3} sx={{mt: 5}}>
                <div className={styles.cardContainer}>
                  <div className={styles.imgContainer}>
                    <Image src={deenfund} alt="person" />
                  </div>
                  <div className={styles.teacherInfo}>
                    <p>Accept one-time and monthly donations from awesome donors worldwide.</p>
                    <Link href="https://deenfund.com/">
                    Learn More
                      <LaunchRoundedIcon fontSize="small" />
                    </Link>
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} sx={{mt: 5}}>
                <div className={styles.cardContainer}>
                  <div className={styles.imgContainer}>
                    <Image src={deenconnect} alt="person" />
                  </div>
                  <div className={styles.teacherInfo}>
                    <p>A single, powerful and easy-to-use platform to handle all of your organization’s needs.</p>
                    <Link href="https://deenconnect.io/">
                    Learn More
                      <LaunchRoundedIcon fontSize="small" />
                    </Link>
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} sx={{mt: 5}}>
                <div className={styles.cardContainer}>
                  <div className={styles.imgContainer}>
                    <Image src={webformasjid} alt="person" />
                  </div>
                  <div className={styles.teacherInfo}>
                    <p>Websites built to connect communities and organizations with their users.</p>
                    <Link href="https://websiteformasjid.com/">
                    Learn More
                      <LaunchRoundedIcon fontSize="small" />
                    </Link>
                  </div>
                </div>
              </Grid>
              
            </Grid>
          </div>
        </Container>
      </div>
    </>
  );
};

export default OthersProducts;
